import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import NewIcon from './NewIcon';

const NotificationIcon = ({ newNotificationCount, ...rest }) => (
  <div className="notification-icon position-relative">
    <Icon name="outline-notifications" {...rest} />
    {newNotificationCount > 0 &&
      <NewIcon number={newNotificationCount} classes="notification-icon__new-icon position-absolute box-shadow" />
    }
  </div>
);

NotificationIcon.propTypes = {
  newNotificationCount: PropTypes.number,
};

export default NotificationIcon;



// WEBPACK FOOTER //
// ./library/app/components/Global/Icons/NotificationIcon.js